module.exports = __webpack_public_path__ + "static/media/magnetLanding.89665893.PNG";